import { createFeatureSelector } from '@ngrx/store';
import { RegistryModuleState } from './registry.reducer';

export const getRegistryFeatureState =
  createFeatureSelector<RegistryModuleState>('registry');
